import React from "react";
import "../css/SystemIntegrator.css";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import { connect } from "react-redux";
import * as ActionTypes from "../actions/types";
import Loader from "./Loader";
import AddOTABetaUpdated from "./OtaBetaAdd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

class OtaBetaUpdatesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updatesData: [],
      loader: true,
      modalIsOpenAddSI: false, // control slider
      copiedTokenId: null, // track which token was copied
    };
  }

  componentDidMount() {
    this.fetchOtaUpdates();
  }

  fetchOtaUpdates = () => {
    this.setState({ loader: true });
    const tokenStored = `Token ${localStorage.getItem("token")}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: tokenStored,
      "X-CSRFToken": localStorage.getItem("csrftoken"),
    };

    fetch("/cloud/ota-update-beta/", { method: "GET", headers })
      .then((response) => {
        if (response.status === 403) {
          localStorage.clear();
          window.location.href = "/session-timeout";
        } else {
          return response.json();
        }
      })
      .then((data) => {
        this.setState({
          updatesData: Array.isArray(data) ? data : [],
          loader: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ updatesData: [], loader: false });
      });
  };

  downloadFile = (url) => {
    window.open(url, "_blank");
  };

  openAddOTASlider = () => {
    this.setState({ modalIsOpenAddSI: true });
  };

  closeAllModal = () => {
    this.setState({ modalIsOpenAddSI: false });
    this.fetchOtaUpdates(); // refresh list after adding
  };

  handleCopy = (token, id) => {
    navigator.clipboard.writeText(token);
    this.setState({ copiedTokenId: id });

    // reset icon after 2 seconds
    setTimeout(() => this.setState({ copiedTokenId: null }), 2000);
  };

  render() {
    const { loader, updatesData, modalIsOpenAddSI, copiedTokenId } = this.state;

    return (
      <React.Fragment>
        {loader && <Loader />}

        {/* Add OTA Button (Top Right) */}
        <div className="pointer" style={{ width: "100%", padding: "20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2 style={{ color: "#888888" }}>OTA Beta Updates</h2>
            <div
              className="buttonContent"
              style={{
                backgroundColor: "white",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                marginBottom: "10px",
              }}
            >
              <IconButton
                sx={{
                  color: "#F08100",
                  fontSize: 40,
                  backgroundColor: "transparent",
                  "&:hover": { backgroundColor: "transparent" },
                  "&:focus": { outline: "none", border: "none" },
                }}
                aria-label="add"
                onClick={this.openAddOTASlider}
              >
                <AddIcon sx={{ fontSize: 30 }} />
              </IconButton>
              <span
                style={{
                  color: "#888888",
                  fontSize: "10px",
                  fontWeight: "600",
                  alignSelf: "center",
                }}
              >
                ADD OTA
              </span>
            </div>
          </div>

          {/* OTA Updates Table */}
          <table className="table">
            <thead
              className="tableHeaderColor"
              style={{ backgroundColor: "#f5f5f5" }}
            >
              <tr>
                <th style={styles.header}>S.No</th>
                <th style={styles.header}>Version</th>
                <th style={styles.header}>Description</th>
                <th style={styles.header}>Instructions</th>
                <th style={styles.header}>Token</th>
                <th style={styles.header}>Download</th>
              </tr>
            </thead>
            <tbody>
              {updatesData.length > 0 ? (
                updatesData.map((update, index) => (
                  <tr key={update.id || index}>
                    <td style={styles.cell}>{index + 1}</td>
                    <td style={styles.cell}>{update.version}</td>
                    <td style={styles.cell}>{update.description}</td>
                    <td style={styles.cell}>{update.instructions}</td>
                    <td style={{ padding: "8px" }}>
                      {update.token}
                      {copiedTokenId === update.id ? (
                        <CheckIcon
                          style={{
                            fontSize: "16px",
                            marginLeft: "8px",
                            cursor: "pointer",
                            color: "green",
                            transition: "0.3s",
                          }}
                          titleAccess="Copied!"
                        />
                      ) : (
                        <ContentCopyIcon
                          onClick={() => this.handleCopy(update.token, update.id)}
                          style={{
                            fontSize: "16px",
                            marginLeft: "8px",
                            cursor: "pointer",
                            color: "#1976d2",
                            transition: "0.3s",
                          }}
                          titleAccess="Copy to clipboard"
                        />
                      )}
                    </td>
                    <td style={styles.cell}>
                      <IconButton
                        onClick={() => this.downloadFile(update.package_path)}
                        sx={{ color: "#2980B9" }}
                      >
                        <FileDownloadIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={styles.cell} colSpan="6">
                    No OTA Beta updates found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Add OTA Slider */}
        {modalIsOpenAddSI && (
          <AddOTABetaUpdated
            activeModal={true}
            closeAllModal={this.closeAllModal}
          />
        )}
      </React.Fragment>
    );
  }
}

const styles = {
  header: {
    fontSize: "12px",
    textAlign: "center",
    verticalAlign: "middle",
    color: "#000",
    fontWeight: "bold",
  },
  cell: {
    fontSize: "12px",
    textAlign: "center",
    verticalAlign: "middle",
    wordBreak: "break-word",
  },
};

const mapStateToProps = (state) => ({
  redux: state,
});

const mapDispatchToProps = (dispatch) => ({
  searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(OtaBetaUpdatesList);
